import React from "react";
import { MediaData } from "../../assets/media";
import MediaImg from "../../assets/newsMedia.webp";
import "./index.css";

const NewsArticle = () => {
  return (
    <div className="news-page">
      <div className="img-container">
        <img className="about-image1" src={MediaImg} alt="News and Media" />
        <div className="text-overlay">News &amp; Media</div>
      </div>

      <p className="news-intro">
        Check out news and insights about Capri Xponentia Managers LLP, and
        remain updated about the latest developments in the stressed asset
        segment.
      </p>

      <div className="news-grid">
        {MediaData.map((item, index) => (
          <div key={index} className="news-card">
            <div className="news-card__image-wrapper">
              <img
                src={item.image}
                alt={item.heading}
                className="news-card__image"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
            <div className="news-card__body">
              <span className="news-card__date">
                {new Date(item.time).toLocaleDateString("en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
              <h3 className="news-card__heading">{item.heading}</h3>
              <p className="news-card__description">{item.description}</p>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="news-card__link"
              >
                Read More
                <span className="news-card__link-arrow">&#8594;</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsArticle;
